import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));

// Important: disable strict mode to make draggable list work in development mode
root.render(
  // <React.StrictMode>
  <App />
  // </React.StrictMode>
)


